import { useEffect, useState } from 'react';
import Default from '../components/layout/Default';
import LabPreviewModal from '../components/lab-preview/LabPreviewModal';
import labProductsData from '../data/functional-lab-products.json';
import { preloadImages } from '../utils/preloadImages';
import './home.scss';

function getProductImageSrcs(product) {
  if (product.images?.length) {
    return product.images.map((image) => image.src).filter(Boolean);
  }

  if (product.image) {
    return [product.image];
  }

  return [];
}

const LAB_PRODUCT_IMAGE_URLS = Object.values(labProductsData.products ?? {}).flatMap(
  getProductImageSrcs
);

function getLabProduct(href) {
  return labProductsData.products?.[href] ?? null;
}

const FUNCTIONAL_LAB_TESTS = [
  {
    title: 'Candida, Metabolic & Vitamins',
    icon: 'fa-mortar-pestle',
    href: 'https://equi.life/products/organic-acids-test',
  },
  {
    title: 'Food Sensitivity Test',
    icon: 'fa-bowl-food',
    href: 'https://equi.life/products/food-sensitivity-test',
  },
  {
    title: 'Minerals and metals',
    icon: 'fa-cube',
    href: 'https://equi.life/products/hair-tissue-mineral-analysis-test',
  },
  {
    title: 'Toxic heavy metals',
    icon: 'fa-biohazard',
    href: 'https://equi.life/products/complete-toxic-heavy-metals-test',
  },
  {
    title: 'Mind & Body Neurotransmitter',
    icon: 'fa-brain',
    href: 'https://equi.life/products/mind-mood-neurotransmitter-test',
  },
  {
    title: 'Gut Bacteria & Parasites',
    icon: 'fa-bacteria',
    href: 'https://equi.life/products/stool-test',
  },
  {
    title: 'Mold Toxicity',
    icon: 'fa-xmarks-lines',
    href: 'https://equi.life/products/mold-toxicity-test',
  },
  {
    title: 'Omega 3 & Inflammation',
    icon: 'fa-3',
    href: 'https://equi.life/products/omega-3-test',
  },
  {
    title: 'Stress, Mood and Metabolism',
    icon: 'fa-sun',
    href: 'https://equi.life/products/thyroid-adrenal-hormones-test',
  },
];

const Labs = (props) => {
  const [selectedTest, setSelectedTest] = useState(null);

  useEffect(() => {
    preloadImages(LAB_PRODUCT_IMAGE_URLS);
  }, []);

  return (
    <Default backgroundImage="/img/labs.jpg">
      <h1 className="pagetitle">Functional Labs</h1>
      <div className="card-container card-container--labs">
        {FUNCTIONAL_LAB_TESTS.map((test) => {
          const product = getLabProduct(test.href);

          return (
            <div key={test.href} className="card-lab-tile-wrap">
              <span className="card-lab-tile__hint" aria-hidden="true">
                <i className="fa-solid fa-magnifying-glass"></i>
              </span>
              <div
                className="card card--clickable card--lab-tile"
                role="button"
                tabIndex={0}
                aria-label={`View details for ${test.title}`}
                onClick={() => setSelectedTest({ ...test, product })}
                onKeyDown={(event) => {
                  if (event.key === 'Enter' || event.key === ' ') {
                    event.preventDefault();
                    setSelectedTest({ ...test, product });
                  }
                }}
              >
                <div className="card-icon">
                  <i className={`fa-solid ${test.icon}`}></i>
                </div>
                <div className="card-title">{test.title}</div>
                {product?.subtitle && (
                  <p className="card-lab-tile__description">{product.subtitle}</p>
                )}
              </div>
            </div>
          );
        })}
      </div>
      {selectedTest && (
        <LabPreviewModal
          test={selectedTest}
          onClose={() => setSelectedTest(null)}
        />
      )}
      <p className="center" style={{ marginTop: '-10px' }}>
        (see website:{' '}
        <a href="https://equi.life/products" target="_blank" rel="noreferrer">
          equi.life/products
        </a>{' '}
        for more details)
      </p>
      <div style={{ marginBottom: '60px' }} />
      <h1 className="pagetitle">Wellness Goals</h1>
      <div className="card-container">
        <div className="card">
          <div className="card-icon">
            <i className="fa-solid fa-bolt"></i>
          </div>
          <div className="card-title">Increase Energy</div>
        </div>
        <div className="card">
          <div className="card-icon">
            <i className="fa-solid fa-weight-scale"></i>
          </div>
          <div className="card-title">Weight loss</div>
        </div>
        <div className="card">
          <div className="card-icon">
            <i className="fa-solid fa-scale-balanced"></i>
          </div>
          <div className="card-title">Rebalance hormones</div>
        </div>

        <div className="card">
          <div className="card-icon">
            <i className="fa-solid fa-cloud"></i>
          </div>
          <div className="card-title">Eliminate brain fog</div>
        </div>
        <div className="card random-image" style={{backgroundImage: "url('/img/food.jpg')"}}>

        </div>
        <div className="card">
          <div className="card-icon">
            <i className="fa-solid fa-wheat-awn-circle-exclamation"></i>
          </div>
          <div className="card-title">Solve digestive issues</div>
        </div>

        <div className="card">
          <div className="card-icon">
            <i className="fa-solid fa-shield"></i>
          </div>
          <div className="card-title">Enhance the immune system</div>
        </div>
        <div className="card">
          <div className="card-icon">
            <i className="fa-solid fa-bed"></i>
          </div>
          <div className="card-title">Better sleep</div>
        </div>
        <div className="card">
          <div className="card-icon">
            <i className="fa-solid fa-fire-flame-simple"></i>
          </div>
          <div className="card-title">Reduce stress</div>
        </div>
      </div>
    </Default>
  );
};

export default Labs;
